/**
 * Базовый URL API. Для смены окружения задайте VUE_APP_API_BASE в .env
 */
export const API_BASE = process.env.VUE_APP_API_BASE || 'https://api.cfbon.ru';

export const API_ENDPOINTS = {
  feedback: `${API_BASE}/feedbackApi/feedback.php`,
  shops: `${API_BASE}/feedbackApi/shops.php`,
};
